import { useState } from "react";
import { api, setToken } from "@/lib/api";
import { toast } from "sonner";
import { Phone, Lock, LogIn } from "lucide-react";

export default function Auth({ onAuthed }) {
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { phone, password });
      setToken(data.token);
      onAuthed(data.user);
      toast.success("Giriş başarılı");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "İşlem başarısız");
    }
    setLoading(false);
  };

  return (
    <div className="min-h-[calc(100vh-4rem)] bg-[var(--fb-neutral)] grid place-items-center px-4 py-10">
      <div className="w-full max-w-md bg-white rounded-2xl border border-[var(--fb-border)] p-6 sm:p-8 animate-fade-up">
        <div className="flex flex-col items-center mb-6">
          <img src="/logo.jpeg" alt="Deny's" className="h-14 object-contain mb-3" />
          <h1 className="font-display font-extrabold text-2xl">Yönetim Girişi</h1>
          <p className="text-sm text-[var(--fb-muted)] mt-1">Telefon ve şifrenizle giriş yapın</p>
        </div>

        <form onSubmit={submit} className="space-y-3">
          <div className="relative">
            <Phone className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--fb-muted)]" />
            <input
              data-testid="auth-phone"
              value={phone}
              onChange={(e) => setPhone(e.target.value)}
              placeholder="Telefon numarası"
              className="w-full border border-[var(--fb-border)] rounded-xl pl-9 pr-3 py-3 outline-none focus:border-[var(--fb-red)]"
            />
          </div>
          <div className="relative">
            <Lock className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-[var(--fb-muted)]" />
            <input
              data-testid="auth-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Şifre"
              className="w-full border border-[var(--fb-border)] rounded-xl pl-9 pr-3 py-3 outline-none focus:border-[var(--fb-red)]"
            />
          </div>

          <button
            data-testid="auth-submit-btn"
            type="submit"
            disabled={loading}
            className="w-full flex items-center justify-center gap-2 bg-[var(--fb-red)] hover:bg-[var(--fb-red-hover)] disabled:opacity-60 text-white font-bold py-3.5 rounded-full transition-colors active:scale-[0.99]"
          >
            <LogIn className="w-5 h-5" />
            {loading ? "Lütfen bekleyin..." : "Giriş Yap"}
          </button>
        </form>

        <p className="text-center text-xs text-[var(--fb-muted)] mt-4">
          Şube hesapları patron tarafından oluşturulur.
        </p>
      </div>
    </div>
  );
}
